/** @jsxImportSource @emotion/react */
import { PieChart } from '@mui/x-charts';
import * as s from './style';
import React, { useEffect, useRef, useState } from 'react';
import { ExpandMore, ExpandLess } from '@mui/icons-material';


const GraphPopup = ({ mapData, selectedSubArray, selectedData }) => {
    const popupRef = useRef();
    const [chartData, setChartData] = useState([]);
    const [ isOpen, setIsOpen ] = useState(true);

    const [ position, setPosition ] = useState({ x: 50, y: 50 })
    const [ isDrag, setIsDrag ] = useState(false);
    const offsetRef = useRef({ x: 0, y: 0 });

    const lastUpdateTimeRef = useRef(0);

    useEffect(() => {
        if (mapData) {
            const uniqueIds = Array.from(new Set(mapData.map((data) => data.get('id'))));

            const newChartData = uniqueIds.map((id) => {
                const filteredData = mapData.filter((data) => data.get('id') === id);
                const sub = selectedSubArray.find((sub) => sub.id === id);
                return { id: id, value: filteredData.length, color: filteredData[0].get('COLOR'), label: sub.name };
            });

            setChartData(newChartData);
        } else {
            setChartData([]);
        }
    }, [mapData]);

    const onClickFoldButton = () => {
        setIsOpen(!isOpen);
    }

    const calcChartHeight = () => {
        const elHeight = document.querySelector(".MuiChartsLegend-root")?.getBoundingClientRect().height;

        if(elHeight) {
            return 265 + elHeight
        }

        return 265;
    }
    
    return (
        <div css={s.mainContainer}>
                <div css={s.chartContainer}>
                <header css={s.chartHeader(isOpen)}>
                    <div css={s.headerText}>
                        <span>{selectedData.name}</span>
                    </div>
                    <div css={s.foldButton} onClick={onClickFoldButton}>
                        {isOpen ? <ExpandMore /> : <ExpandLess />}
                    </div>
                </header>
                {isOpen &&
                    <div css={s.chartArea}>
                        {chartData.length > 0 ?
                            <PieChart
                                series={[
                                    {
                                        data: chartData,
                                        innerRadius: 60,
                                        outerRadius: 100,
                                        cx: 145,
                                        cy: 120,
                                    },
                                ]}
                                width={300}
                                height={calcChartHeight()}
                                slotProps={{
                                    legend: {
                                        direction: 'row',
                                        position: { vertical: 'bottom', horizontal: 'middle' },
                                        padding: 0,
                                        labelStyle: {
                                            fontSize: '14px',
                                        },
                                        itemMarkHeight: 10,
                                        itemMarkWidth: 10,
                                        style: {
                                            height: '1px'
                                        }
                                    },
                                }}
                            />
                            : <div css={s.textContainer}>
                                <span id="테스트">데이터가 존재하지 않습니다.</span>
                            </div>
                        }
                    </div>
                }
                </div>
        </div>
    );
};

export default GraphPopup;